import { PaginationOrderEnum as e } from "../../../enums/pagination-enums.mjs";
import { httpClient as t } from "../../../utils/http-client.mjs";
import { COMMON_DATA_FILES_API_BASE_PATH as n, DATA_FILES_API_BASE_PATH as r } from "../../file-uploader/api/index.mjs";
import { useInfiniteQuery as i, useQuery as a, useQueryClient as o } from "@tanstack/react-query";
//#region src/modules/file-selector/hooks/use-data-files.ts
var s = async ({ startFrom: e, limit: i, order: a, sortColumn: o, sortDirection: s, filter: c, fileManagerApiType: l }) => (await t.get((l?.isCommon ? n : r) + "?" + (c?.name ? `&filter[names][]=${c?.name}` : "") + (c?.source?.length ? c.source.map((e) => `&filter[sources][]=${encodeURIComponent(e)}`).join("") : "") + (c?.type?.length ? c.type.map((e) => `&filter[types][]=${encodeURIComponent(e)}`).join("") : "") + (e ? `&pagination[startFrom]=${e}` : "") + (o ? `&pagination[sortColumn]=${o}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (i ? `&pagination[limit]=${i}` : "") + (a ? `&pagination[order]=${a}` : ""))).data, c = ({ startFrom: t, limit: n = 10, order: r = e.Next, sortColumn: i, sortDirection: c, filter: l, fileManagerApiType: u }, d) => {
	let f = o(), p = u?.isCommon ? "common-data-files" : u?.isPublic ? "public-data-files" : "data-files", m = [p], h = [p, {
		startFrom: t,
		limit: n,
		order: r,
		sortColumn: i,
		sortDirection: c,
		filter: l
	}], g = a({
		queryKey: h,
		queryFn: () => s({
			startFrom: t,
			limit: n,
			order: r,
			sortColumn: i,
			sortDirection: c,
			filter: l,
			fileManagerApiType: u
		}),
		...d
	}), _ = () => {
		f.fetchQuery({ queryKey: h });
	}, v = () => {
		f.invalidateQueries({ queryKey: m });
	}, y = (e) => {
		f.getQueryCache().findAll({ queryKey: m }).forEach((t) => {
			f.setQueryData(t.queryKey, (t) => {
				if (t) return {
					...t,
					items: t.items.filter((t) => t.id !== e)
				};
			});
		});
	}, b = ({ id: e, name: t }) => {
		f.getQueryCache().findAll({ queryKey: m }).forEach((n) => {
			f.setQueryData(n.queryKey, (n) => {
				if (n) return {
					...n,
					items: n.items.map((n) => n.id === e ? {
						...n,
						name: t
					} : n)
				};
			});
		});
	};
	return {
		...g,
		resetAndRefetch: v,
		triggerFetch: _,
		deleteItemFromData: y,
		renameItemFromData: b
	};
}, l = ({ limit: t = 10, order: n = e.Next, sortColumn: r, sortDirection: a, filter: c, fileManagerApiType: l }, u) => {
	let d = o(), f = [l?.isCommon ? "common-infinite-data-files" : l?.isPublic ? "public-infinite-data-files" : "infinite-data-files", {
		limit: t,
		order: n,
		sortColumn: r,
		sortDirection: a,
		filter: c
	}], p = i({
		initialPageParam: void 0,
		queryKey: f,
		queryFn: ({ pageParam: e }) => s({
			startFrom: typeof e == "string" ? e : void 0,
			limit: t,
			order: n,
			sortColumn: r,
			sortDirection: a,
			filter: c,
			fileManagerApiType: l
		}),
		getPreviousPageParam: (e) => {
			if (!e.hasMore) return;
			let t = e.items[0];
			if (t) return encodeURIComponent(JSON.stringify({
				id: t.id,
				field: t[r ?? "name"]
			}));
		},
		getNextPageParam: (e) => {
			if (!e.hasMore) return;
			let t = e.items[e.items.length - 1];
			if (t) return encodeURIComponent(JSON.stringify({
				id: t.id,
				field: t[r ?? "name"]
			}));
		},
		...u
	}), m = () => {
		d.invalidateQueries({ queryKey: f });
	}, h = (e) => {
		d.setQueryData(f, (t) => t && {
			...t,
			pages: t.pages.map((t) => ({
				...t,
				items: t.items.filter((t) => t.id !== e)
			}))
		});
	}, g = ({ id: e, name: t }) => {
		d.setQueryData(f, (n) => n && {
			...n,
			pages: n.pages.map((n) => ({
				...n,
				items: n.items.map((n) => n.id === e ? {
					...n,
					name: t
				} : n)
			}))
		});
	};
	return {
		...p,
		resetAndRefetch: m,
		deleteItemFromData: h,
		renameItemFromData: g
	};
};
//#endregion
export { c as useDataFiles, l as useInfiniteDataFiles };
